import _ from 'underscore';

import { entitySchema } from '@bingads-webui-campaign/auction-insight-service';
import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import {
  selectorStyleOptions,
  selectorKeyMapFunc,
  handleFilterChange,
} from '@bingads-webui-campaign-react/campaign-adgroup-selector-filter';
import {
  CAMPAIGN_TYPES,
} from '@bingads-webui-campaign/competition-auction-insight-preferences';

import { DisplayDomainDataSource } from './display-domain-data-source';

function handleFilterChangeForDisplayDomain({
  viewFilter,
  searchFilter,
  stats,
  dataSource,
  selector,
}) {
  handleFilterChange({
    viewFilter,
    searchFilter,
    stats,
    dataSource,
    selector,
    missingDataHandler: ({ data, missingIds }) => {
      const missingData = [];
      _.each(missingIds, (missingId) => {
        missingData.push({
          Id: missingId,
          Name: missingId,
        });
      });

      return missingData.concat(data);
    },
  });
}

export function updateDisplayDomainSchema({
  dataService, campaignType, i18n, permissions,
}) {
  const schemaForFilter = cloneDeep(entitySchema);
  let title = '';

  // piloted properties
  if (!permissions.IsAvgPositionDeprecationPhase1Enabled) {
    schemaForFilter.properties = _.omit(schemaForFilter.properties, 'AbsoluteTopOfPageRate');
  }
  if (permissions.IsAvgPositionDeprecationPhase2Enabled) {
    schemaForFilter.properties = _.omit(schemaForFilter.properties, 'AveragePosition');
  }

  // for shopping, we only show a few columns and title is different for property displaydomain.
  if (campaignType === CAMPAIGN_TYPES.Shopping) {
    title = i18n.getString('Schema_AuctionInsight_Property_StoreDisplayName');
    schemaForFilter.properties = _.omit(schemaForFilter.properties, 'AveragePosition', 'AboveRate', 'TopOfPageRate');
  }

  schemaForFilter.properties.DisplayDomain = _.extend(schemaForFilter.properties.DisplayDomain, {
    title,
    type: 'id',
    addtionalParams: {
      dataSource: new DisplayDomainDataSource({ dataService }),
      selectorOptions: {
        filter: {
          showSelected: true,
          showChanged: false,
        },
        handleFilterChange: handleFilterChangeForDisplayDomain,
        keyMap: selectorKeyMapFunc(i18n),
        styles: selectorStyleOptions,
      },
    },
  });

  return schemaForFilter;
}
